import { useNavigate } from "react-router-dom";
import BackIcon from "../../assets/images/BackIcon";
import { pageRouteConstants, StaffListConstants } from "../../constants/constants";
import BackIconInBlack from "../../assets/images/BackIconInBlack";

export const UserExitFLowTitleComponent = () => {
  const navigate = useNavigate();

  return (
    <div className="flex">
      <div
        onClick={() => {
          navigate(pageRouteConstants.dashBoardRoute)
        }}
        className="pt-1 pr-4  cursor-pointer "
      >
        <BackIconInBlack />
      </div>
      <div className="flex flex-col">
        <div
          className="text"
          style={{ fontFamily: "Lexend, sans-serif", fontWeight: 600 }}
        >
          {StaffListConstants.staffExitFlowTitle}
        </div>
        <div className="text-primary flex staffListDownloadCheckbox font-nunito">
          <div className="roleButton text-blackColor pt-2">
            {StaffListConstants.staffInformationDescription}
          </div>
        </div>
      </div>
    </div>
  );
};
